export default __webpack_public_path__ + "locales/el-GR/SalesDepartmentRequestDialog.json?hash=bd1e1de2c295e06b483349811b3000bf";